import {
  RecoSettingsGoals,
  RecoSettingsPrioritisationGoal,
} from '../../types/Recommendations.js';
import { RootState } from '../reducer/index.js';

export const getRecosSettingsPrioritisationGoal = (
  state: RootState,
): RecoSettingsGoals | null =>
  (state.recoSettingsPrioritisationGoal as RecoSettingsPrioritisationGoal)
    .prioritisationGoal;
